import React from "react";
import {FormComponent} from "../../components/FormComponent";
import {User} from "../../components/User";
import {Loader} from "../../components/Loader";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";

export class MyProfile extends FormComponent {
    protected user: User = new User();

    componentDidMount() {
        this.request.fetch('/settings/profile/get')
            .then((data: { elem: { [key: string]: string } | any } | any) => {

                this.setState({
                    email: data.elem.email,
                    language: data.elem.language,
                    name: data.elem.name,
                    role: data.elem.role,
                    status: data.elem.status
                });

            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        (document.querySelector('form .alert.alert-success') as HTMLElement).classList.remove('hide');
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        return (
            <>
                <form className="x-form" action="/settings/profile/save" method="POST" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-12 col-lg-6">
                            <br/>&nbsp;
                            <h5>
                                {this.dictionary.get['my-profile']}
                            </h5>

                            <FormGroup.Input {...{id: 'name', required: true, defaultValue: this.state.name}}/>

                            <FormGroup.Input {...{
                                id: 'email', type: 'email', required: true, defaultValue: this.state.email
                            }}/>

                            <FormGroup.Select {...{
                                id: 'status',
                                disabled: true,
                                items: ['active', 'inactive'],
                                defaultValue: this.state.status
                            }}/>

                            <FormGroup.Select {...{
                                id: 'role',
                                disabled: true,
                                basic: 'please-select',
                                items: ['admin', 'client', 'warehouse-admin'],
                                defaultValue: this.state.role
                            }}/>

                            <FormGroup.Select {...{
                                id: 'language',
                                required: true,
                                items: this.dictionary.languages,
                                defaultValue: this.state.language
                            }}/>

                            <FormSubmit/>
                        </div>

                        <div className="col-md-12 col-lg-6">
                            <br/>&nbsp;
                            <h5>
                                {this.dictionary.get['change-password']}
                            </h5>
                            <FormGroup.Info>{this.dictionary.get['save-on-fill']}</FormGroup.Info>

                            <FormGroup.Input {...{
                                id: 'password',
                                type: 'password',
                                help: 'min-8-char',
                                autoComplete: this.dictionary.get['new-password']
                            }}/>

                            <FormGroup.Input {...{
                                id: 'passwordRe',
                                type: 'password',
                                autoComplete: this.dictionary.get['new-password']
                            }}/>
                        </div>
                    </div>
                </form>
            </>
        );
    }
}